// const URL_PREFIX = '/api/v0'
const URL_PREFIX = 'https://api.pryph.org/api/v0'

// ?????? const URL_PREFIX ='https://api.pryph.org/v1'

export { URL_PREFIX }
